import { isUndefined } from 'lodash';
import React, { useMemo } from 'react';

export function AttributePreview({ title, value, unit, icon }) {
  const hasDecimals = useMemo(() => value % 1 !== 0, [value]);

  return (
    <div className="meteo-sensor-detail-attribute-preview">
      <div className="icon">{icon}</div>
      <p className="value">
        {!isUndefined(value)
          ? new Intl.NumberFormat('sk-SK', {
              minimumFractionDigits: hasDecimals ? 2 : 0,
            }).format(value)
          : '-'}
        <span>{unit}</span>
      </p>
      <p className="title">{title}</p>
    </div>
  );
}
